import { render, staticRenderFns } from "./NewTableView.vue?vue&type=template&id=2c5605d2&scoped=true&"
import script from "./NewTableView.vue?vue&type=script&lang=js&"
export * from "./NewTableView.vue?vue&type=script&lang=js&"
import style0 from "./NewTableView.vue?vue&type=style&index=0&id=2c5605d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5605d2",
  null
  
)

export default component.exports